"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadingBasic = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var styled_components_1 = __importDefault(require("styled-components"));
var core_1 = require("@material-ui/core");
var MBText_1 = require("../MBText");
var Container = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n\n  width: ", ";\n  height: ", ";\n  overflow: hidden;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: white;\n  font-weight: 800;\n  font-size: 25em;\n  will-change: transform, opacity;\n  text-shadow: 0px 2px 40px #00000020, 0px 2px 5px #00000030;\n"], ["\n  ",
    "\n\n  width: ", ";\n  height: ", ";\n  overflow: hidden;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: white;\n  font-weight: 800;\n  font-size: 25em;\n  will-change: transform, opacity;\n  text-shadow: 0px 2px 40px #00000020, 0px 2px 5px #00000030;\n"])), function (_a) {
    var absolute = _a.absolute;
    return absolute &&
        "\n    position: absolute;\n  left: 0;\n  top: 0;\n  ";
}, function (_a) {
    var width = _a.width;
    return width;
}, function (_a) {
    var height = _a.height;
    return height;
});
var LoadingBasic = function (_a) {
    var _b = _a.width, width = _b === void 0 ? '100%' : _b, _c = _a.height, height = _c === void 0 ? '100%' : _c, _d = _a.color, color = _d === void 0 ? '#000' : _d, _e = _a.bgcolor, bgcolor = _e === void 0 ? '#fff' : _e, _f = _a.absolute, absolute = _f === void 0 ? false : _f, _g = _a.text, text = _g === void 0 ? '' : _g;
    return (jsx_runtime_1.jsx(Container, __assign({ width: width, height: height, absolute: absolute }, { children: jsx_runtime_1.jsx(core_1.Box, __assign({ display: "flex", alignItems: "center", justifyContent: "center", width: "100%", height: "100%", bgcolor: bgcolor, color: color }, { children: jsx_runtime_1.jsx(core_1.Box, __assign({ position: "absolute", width: "100%", height: "100%", top: 0, left: 0, display: "flex", alignItems: "center", justifyContent: "center" }, { children: text ? (jsx_runtime_1.jsxs(core_1.Box, __assign({ display: "flex", flexDirection: "column", alignItems: "center" }, { children: [jsx_runtime_1.jsx(core_1.Box, __assign({ mb: 2, display: "flex" }, { children: jsx_runtime_1.jsx(core_1.CircularProgress, { color: "inherit" }, void 0) }), void 0),
                        jsx_runtime_1.jsx(MBText_1.MBText, { variant: "body2", t: text }, void 0)] }), void 0)) : (jsx_runtime_1.jsx(core_1.CircularProgress, { color: "inherit" }, void 0)) }), void 0) }), void 0) }), void 0));
};
exports.LoadingBasic = LoadingBasic;
var templateObject_1;
//# sourceMappingURL=LoadingBasic.js.map